// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"5db50bf3","453":"f9bbebaa"}[chunkId] + ".chunk.js";
};